import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import PostHooks from "../../../Api/PostHooks";
import AlertComponent from "../../../Components/AlertComponent";
import { Link, useNavigate } from "react-router-dom";

const ForgotPasswordForm = () => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const [loading, response, request] = PostHooks();
  const [resetLoading, resetResponse, resetRequest] = PostHooks();

  const msisdn = watch("msisdn");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async () => {
    try {
      if (msisdn === undefined || msisdn.length < 13) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Input a valid phone number!",
        });
      } else {
        let formData = {
          msisdn: msisdn.replace("+", ""),
        };

        const otpResp = await request({
          url: "/forgot_password",
          body: formData,
        });

        if (
          otpResp &&
          otpResp.status === 200 &&
          otpResp.data.StatusCode === 0
        ) {
          setSnackbar({
            open: true,
            severity: "success",
            message: "Otp sent, check phone!",
          });
        } else {
          const errorMessage =
            otpResp?.data?.StatusMessage ??
            otpResp?.data?.message ??
            "An unexpected error occurred. Please try again.";

          setSnackbar({
            open: true,
            severity: "error",
            message: errorMessage,
          });
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const onSubmitOtp = async (e) => {
    try {
      let formData = {
        msisdn: msisdn.replace("+", ""),
        otp: e.otp,
        pin: e.pin,
      };

      const resetResp = await resetRequest({
        url: "/reset_password",
        body: formData,
      });

      if (
        resetResp &&
        resetResp.status === 200 &&
        resetResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Pin reset successful.Redirecting...",
        });
      } else {
        const errorMessage =
          resetResp?.data?.StatusMessage ??
          resetResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      {response === undefined ||
      (response && response.data.StatusCode !== 0) ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack direction="column" alignItems="center" spacing={6}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" align="center" gutterBottom>
                Reset your PIN.
              </Typography>
              <Typography sx={{ color: "text.secondary" }} align="center">
                Provide your Mobile Number
              </Typography>
            </Box>
          </Stack>

          <Grid
            item
            xs={12}
            sx={{
              paddingTop: "20px",
            }}
          >
            <Controller
              name="msisdn"
              control={control}
              rules={{
                validate: (value) => matchIsValidTel(value),
              }}
              defaultValue={"+254"}
              render={({ field, fieldState }) => (
                <MuiTelInput
                  {...field}
                  fullWidth
                  defaultCountry="KE"
                  onlyCountries={["KE"]}
                  helperText={
                    fieldState.invalid ? "Invalid mobile number!" : ""
                  }
                  error={fieldState.error}
                  value={field.value || ""}
                  disableFormatting
                />
              )}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              paddingTop: "30px",
              gap: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* <Button variant="outlined" fullWidth onClick={() => navigate(-1)}>
              Back
            </Button> */}
            <LoadingButton
              variant="contained"
              size="large"
              type="submit"
              loading={loading}
              fullWidth
            >
              Reset
            </LoadingButton>
          </Grid>
        </form>
      ) : (
        <>
          <form onSubmit={handleSubmit(onSubmitOtp)}>
            <Stack direction="column" alignItems="center" spacing={6}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" align="center" gutterBottom>
                  Reset your PIN.
                </Typography>
                <Typography sx={{ color: "text.secondary" }} align="center">
                  Provide OTP sent to your mobile
                </Typography>
              </Box>
            </Stack>

            <Grid
              item
              xs={12}
              sx={{
                paddingTop: "20px",
              }}
            >
              <FormControl fullWidth error={!!errors.otp}>
                <InputLabel htmlFor="otp">OTP</InputLabel>
                <OutlinedInput
                  id="otp"
                  type="number"
                  {...register("otp", {
                    required: true,
                    maxLength: 4,
                    minLength: 4,
                  })}
                  label="OTP"
                />
                {errors.otp && (
                  <FormHelperText>Please enter a valid otp!</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingTop: "20px",
              }}
            >
              <FormControl fullWidth error={!!errors.pin}>
                <InputLabel htmlFor="pin">Enter new pin</InputLabel>
                <OutlinedInput
                  id="pin"
                  {...register("pin", {
                    required: true,
                  })}
                  label="Enter new pin"
                />
                {errors.pin && (
                  <FormHelperText>Please enter your pin!</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingTop: "20px",
              }}
            >
              <FormControl fullWidth error={!!errors.confirm_pin}>
                <InputLabel htmlFor="confirm_pin">Confirm new pin</InputLabel>
                <OutlinedInput
                  id="confirm_pin"
                  {...register("confirm_pin", {
                    required: true,
                    validate: (val) => {
                      if (watch("pin") !== val) {
                        return "Your pins do not match";
                      }
                    },
                  })}
                  label="Confirm new pin"
                />
                {errors.confirm_pin && (
                  <FormHelperText>Invalid pin!</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingTop: "30px",
                gap: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <LoadingButton
                variant="contained"
                size="large"
                type="submit"
                loading={resetLoading}
                fullWidth
              >
                Reset
              </LoadingButton>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                pt: "10px",
              }}
            >
              <Button
                variant="text"
                type="button"
                onClick={() => {
                  // navigate("/forgot-password");
                  window.location.reload();
                }}
              >
                Resend otp
              </Button>
            </Grid>
          </form>
        </>
      )}

      <Box
        sx={{
          pt: 2,
          display: "flex",
          // gap: "20px",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body2" align="">
          Back to{" "}
          <Link variant="subtitle2" component={""} to={"/login"}>
            Login
          </Link>
        </Typography>
      </Box>
    </>
  );
};

export default ForgotPasswordForm;
